import barba from '@barba/core';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Plyr from 'plyr';
import "@lottiefiles/lottie-player";

gsap.registerPlugin(ScrollTrigger);



const imagesLoaded = require('imagesloaded');
const transitionElement = document.querySelector('#transition');
const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;
const logoPeriod = document.getElementById("logo_period");
const logoPeriodLocation = logoPeriod.getBoundingClientRect();

let clipPathStart;
let clipPathEnd;
let mouseX, mouseY;

document.addEventListener("click", (event) => {
    mouseX = event.clientX;
    mouseY = event.clientY;
});


function baseInit()
{
    // Inline videos and animations
    const videos = document.querySelectorAll('[playsinline]');
                
    if (videos.length > 0)
    {
        [...videos].forEach((video) => {
            const videoSource = video.querySelector('source').dataset.src;

            if (typeof videoSource != "undefined")
            {
                video.querySelector('source').src = videoSource;
            }

            video.load();

            video.addEventListener("canplaythrough", (event) => {
                video.play();
            });
        });
    }


    // Process List
    const processListItems = document.querySelectorAll('.processList__item');

    if (processListItems.length > 0)
    {
        [...processListItems].forEach((element, index) => {
            let showDelay = 300, hideDelay = 300;
            let menuEnterTimer, menuLeaveTimer;

            const processItemTimeline = gsap.timeline(
                {
                    scrollTrigger: 
                    {
                        trigger: element,
                        start: "top center",
                        end: "bottom center",
                        scrub: 0.5,
                        markers: false,
                        toggleClass: 
                        {
                            targets: element.querySelector(".processList__item-description"),
                            className: "active-scroll"
                        }
                    }
                }
            );

            element.addEventListener('mouseenter', function() {
                let thisItem = this;

                clearTimeout(menuLeaveTimer);

                document.querySelector(".processList__item-description").classList.remove('active');

                menuEnterTimer = setTimeout(function() {
                    thisItem.querySelector(".processList__item-description").classList.add('active');
                }, showDelay);
            });

            element.addEventListener('mouseleave', function() {
                let thisItem = this;

                clearTimeout(menuEnterTimer);

                menuLeaveTimer = setTimeout(function() {
                    thisItem.querySelector(".processList__item-description").classList.remove('active');
                }, hideDelay);
            });
        });
    }


    // Calls to Action
    const callsToAction = document.querySelectorAll('.callToAction');

    if (callsToAction.length > 0)
    {
        [...callsToAction].forEach((element, index) => {
            const phrase = element.querySelector('.callToAction__phrase');

            const viewportWidth = window.innerWidth;
            const phraseTargetX = 0 - (element.scrollWidth - (viewportWidth / 2));

            gsap.set(phrase, {x: "50%"});

            const callToActionTimeline = gsap.timeline(
                {
                    scrollTrigger: 
                    {
                        target: phrase,
                        trigger: element,
                        start: "top center",
                        end: "bottom center",
                        invalidateOnRefresh: true,
                        scrub: 1,
                        markers: false
                    }
                }
            ).fromTo(phrase, {x: "50%"}, {x: phraseTargetX});
        });
    }


    // Lottie Play on View
    const lottiePlayOnView = document.querySelectorAll('[lottie-play-on-view]');

    if (lottiePlayOnView.length > 0)
    {
        [...lottiePlayOnView].forEach((element, index) => {
            ScrollTrigger.create({
                trigger: element,
                start: "top center",
                onEnter: () => {
                    element.play();
                }
            });
        });
    }


    // ScrollTrigger Refresh
    setTimeout(() => {
        ScrollTrigger.refresh();
    }, 800);


    // Video Players (with controls)
    const videoPlayers = document.querySelectorAll('.videoPlayer--type-standard');

    if (videoPlayers.length > 0)
    {
        [...videoPlayers].forEach((element) => {
            const player = new Plyr(element.querySelector('.videoPlayer'), {
                controls: ['play-large','play','progress']
            });
        });
    }


    // Video Poster
    const videoPosters = document.querySelectorAll('.videoPlayer--type-poster');

    if (videoPosters.length > 0)
    {
        [...videoPosters].forEach((element, index) => {
            const poster = element.querySelector('.videoPlayer__poster');
            const player = new Plyr(element.querySelector('.videoPlayer'), {
                controls: ['play-large','play','progress']
            });

            player.on("ended", () => {
                poster.classList.remove('helper--visuallyHidden');
                gsap.to(poster, { opacity: 1, delay: 0.5, duration: 0.5, onComplete: () => {
                    player.stop();
                }});
            });

            poster.addEventListener("click", () => {
                gsap.to(poster, { opacity: 0, duration: 0.5, onComplete: () => {
                    poster.classList.add('helper--visuallyHidden');
                    player.play();
                }});
            });
        });
    }

}

function transition()
{
    // // Page transitions
    // const transitionElement = document.querySelector('#transition');

    // if (transitionElement != null)
    // {
    //     if (!transitionElement.classList.contains('animated') && transitionElement.classList.contains('animatedOut'))
    //     {
    //         const viewportWidth = window.innerWidth;
    //         const viewportHeight = window.innerHeight;

    //         const logoPeriod = document.getElementById("logo_period");
    //         const logoPeriodLocation = logoPeriod.getBoundingClientRect();
            
    //         const periodOffsetX = 2;
    //         const periodOffsetY = 2;
    //         const periodLeft = logoPeriodLocation.left + periodOffsetX;
    //         const periodTop = logoPeriodLocation.top + periodOffsetY;

    //         const leftPercent = periodLeft / viewportWidth * 100;
    //         const topPercent = periodTop / viewportHeight * 100;

    //         const clipPathStart = "circle(140% at " + leftPercent + "% " + topPercent + "%)";
    //         const clipPathEnd = "circle(0% at " + leftPercent + "% " + topPercent + "%)";

    //         gsap.fromTo(transitionElement.querySelectorAll('.transitionElement'), {clipPath: clipPathStart}, {stagger: -0.05, clipPath: clipPathEnd, ease: "power4.inOut", duration: 0.7, onComplete: () => {
    //             transitionElement.classList.remove("animatedOut");
    //             transitionElement.classList.add("animated");
    //         }});
    //     }
    //     else
    //     {
            const siteIntroductionElement = document.querySelector('.site_introduction');
            const siteIntroductionAnimation = document.querySelector('#siteIntroductionAnimation');

            if (siteIntroductionElement != null)
            {
                siteIntroductionAnimation.classList.add("visible");

                gsap.fromTo(siteIntroductionAnimation.querySelectorAll('path'), {y: 50, opacity: 0}, {y: 0, opacity: 1,  ease: "power4.out", delay: 0.25, stagger: {from: "start", each: 0.03}});
                gsap.to(siteIntroductionAnimation, {opacity: 0, ease: "power4.in", delay: 1.5, onComplete: () => {
                    siteIntroductionAnimation.classList.remove("visible");
                    siteIntroductionAnimation.classList.add("hidden");
                }});
            }
            else
            {
                siteIntroductionAnimation.classList.add("hidden");
            }
    //     }
    // }
}


barba.init({
    timeout: 30000,
    transitions: [{
        name: 'default-transition',
        leave: (data) => {
            return new Promise(resolve => {
                gsap.fromTo(transitionElement.querySelectorAll('.transitionElement'), {clipPath: clipPathStart}, {stagger: 0.05, clipPath: clipPathEnd, ease: "power4.inOut", duration: 0.95, onComplete: resolve});
            });
        },
        after: (data) => {
            return new Promise(resolve => {
                gsap.fromTo(transitionElement.querySelectorAll('.transitionElement'), {clipPath: clipPathStart}, {stagger: -0.05, clipPath: clipPathEnd, ease: "power4.inOut", duration: 0.85, onComplete: resolve});
            });
        }
    }]
});


barba.hooks.leave((data) => {

    // console.log('leave');

    const periodLeft = mouseX;
    const periodTop = mouseY;

    const leftPercent = periodLeft / viewportWidth * 100;
    const topPercent = periodTop / viewportHeight * 100;

    clipPathStart = "circle(0% at " + leftPercent + "% " + topPercent + "%)";
    clipPathEnd = "circle(140% at " + leftPercent + "% " + topPercent + "%)";
});


barba.hooks.afterLeave((data) => {

    ScrollTrigger.killAll();
    
});


barba.hooks.beforeEnter((data) => {

    // console.log('beforeEnter');

    // Reset scroll position
    window.scrollTo(0, 0);


    // Setup transition
    const periodOffsetX = 2;
    const periodOffsetY = 2;
    const periodLeft = logoPeriodLocation.left + periodOffsetX;
    const periodTop = logoPeriodLocation.top + periodOffsetY;

    const leftPercent = periodLeft / viewportWidth * 100;
    const topPercent = periodTop / viewportHeight * 100;

    clipPathStart = "circle(140% at " + leftPercent + "% " + topPercent + "%)";
    clipPathEnd = "circle(0% at " + leftPercent + "% " + topPercent + "%)";


    // Preload Images
    const imageElements = data.next.container.querySelectorAll('img');

    if (imageElements.length > 0)
    {
        // console.log('hasImages');
        
        return new Promise(resolve => { 
            imagesLoaded(imageElements, function() {
                // console.log('imagesLoaded');
                resolve();
            });
        });
    }

});


barba.hooks.enter((data) => {

    // console.log('enter');

    baseInit();

});


baseInit();